import React from 'react';

import { useTheme } from '@material-ui/core/styles';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
  testId?: string;
}

const StoreStatusPreOrder = (props: IconProps): JSX.Element => {
  const { size, testId = '' } = props;

  const theme = useTheme();

  return (
    <SvgIcon size={size} data-fd={testId}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12c6.627 0 12-5.373 12-12S18.627 0 12 0z"
        fill={`${theme.palette.warning.main}`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.936 6h-.072a.86.86 0 00-.864.864v5.664c0 .42.216.816.588 1.032l4.98 2.988c.41.24.936.12 1.176-.288a.852.852 0 00-.3-1.188l-4.644-2.76V6.864A.86.86 0 0011.936 6z"
        fill={`${theme.palette.common.white}`}
      />
    </SvgIcon>
  );
};
export default StoreStatusPreOrder;
